import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button,
  Spinner,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Form,
  FormGroup,
  Badge,
  UncontrolledTooltip,
  NavItem,
} from "reactstrap";

const WithdrawTable = ({
  withdrawals,
  selectAll,
  handleSelectAll,
  selectedWithdrawals,
  handleSelectWithdrawal,
  formatDate,
  formatAmount,
}) => {
  const navigate = useNavigate();

  const handleViewWithdraw = (id) => {
    navigate(`/withdraws/${id}`);
  };

  return (
    <div className="table-responsive">
      <Table className="table-nowrap table-hover mb-0">
        <thead className="table-light">
          <tr>
            <th>
              <div className="form-check">
                <Input
                  type="checkbox"
                  id="selectAll"
                  checked={selectAll}
                  onChange={handleSelectAll}
                />
                <Label for="selectAll" className="form-check-label"></Label>
              </div>
            </th>
            <th>User</th>
            <th>Address</th>
            <th>Amount</th>
            <th>Created At</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {withdrawals.map((withdrawal) => (
            <tr key={withdrawal.id}>
              <td>
                <div className="form-check">
                  <Input
                    type="checkbox"
                    id={`select-${withdrawal.id}`}
                    checked={selectedWithdrawals.includes(withdrawal.id)}
                    onChange={() => handleSelectWithdrawal(withdrawal.id)}
                  />
                  <Label
                    for={`select-${withdrawal.id}`}
                    className="form-check-label"></Label>
                </div>
              </td>
              <td>
                <div>
                  <h6 className="mb-0">{withdrawal?.user?.username}</h6>
                  <small className="text-muted">
                    {withdrawal?.user?.email}
                  </small>
                </div>
              </td>
              <td>
                <code className="text-dark" id={`addr-${withdrawal.id}`}>
                  {withdrawal.address.length > 20
                    ? `${withdrawal.address.substring(0, 20)}...`
                    : withdrawal.address}
                </code>
                <UncontrolledTooltip
                  placement="top"
                  target={`addr-${withdrawal.id}`}>
                  {withdrawal.address}
                </UncontrolledTooltip>
              </td>
              <td>
                <Badge color="info" className="font-size-12">
                  {formatAmount(withdrawal.amount)}
                </Badge>
              </td>
              <td>
                <small className="text-muted">
                  {formatDate(withdrawal.createdAt)}
                </small>
              </td>
              <td>
                <Button
                  color="success"
                  size="sm"
                  disabled={withdrawal.status!="pending"}
                  onClick={() => handleViewWithdraw(withdrawal?._id)}>
                  Approve
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default WithdrawTable;
